import { render } from "./RentComponent.vue?vue&type=template&id=2d8c3658&ts=true"
import script from "./RentComponent.vue?vue&type=script&lang=ts"
export * from "./RentComponent.vue?vue&type=script&lang=ts"

import "./RentComponent.vue?vue&type=style&index=0&id=2d8c3658&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__